export default __webpack_public_path__ + "static/media/bgbat.4ce539ec.png";